<template>
  <div class="basic_wrap">
    <!-- 顶部紫色渐变背景区域 -->
    <div
      style="width: 100%;height: 180px;background: linear-gradient(to right bottom, rgb(109, 40, 217), rgb(217, 70, 239), rgb(244, 114, 182));padding-top: 14px;padding-bottom: 28px;padding-left: 14px;padding-right: 14px;"
    >
      <!-- 顶部标题 -->
      <div class="red_top_bg" style="z-index: 1;">
        <div
          style="margin-top: 8px;padding-left: 8px;padding-top: 8px;background-color: #4c1d9566;border-radius: 7px;height: 28px;width: 28px;align-items: center;justify-content: center;"
          @click="$router.back()"
        >
          <svg
            style="font-size: 12px;line-height: 18px;color:#fff;display:inline-block;height: 12px;"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="chevron-left"
            class="svg-inline--fa fa-chevron-left text-white"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          ><path
            fill="currentColor"
            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
          /></svg>
        </div>
        <div class="big_tit" style="top:14px;">
          <div style="padding-left: 4px;width: 100%;height: 26px;line-height: 26px;font-size: 14px;font-weight: 600;color:#fff">
            {{ $t('utils.lcode1') }}
          </div>
          <div style="padding-left: 4px;width: 100%;height: 14px;line-height: 14px;font-size: 10px;font-weight: 400;color:#fff">
            {{ $t('utils.lcode2') }}
          </div>
        </div>
      </div>

      <!-- 统计与上传按钮 -->
      <div
        style="width: 100%;height: 70px;margin-top: 15px;background-color: #ffffff26;border-radius: 14px;align-items: center;padding:20px"
      >
        <div style="gap:10px;align-items: center;float: left;margin-left: 10px;display: flex;">
          <div
            style="background-color: #4c1d9566;width: 42px;height:42px;justify-content: center;border-radius: 10px;align-items: center;display: flex;padding: 13px;"
          >
            <svg
              style="font-size: 12px;line-height: 12px;color:#fff;display:inline-block;height: 12px;"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="circle-check"
              class="svg-inline--fa fa-circle-check text-white text-xl"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            ><path
              fill="currentColor"
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
            /></svg>
          </div>
          <div>
            <p style="color: #fff;font-size: 10px;line-height: 14px">
              {{ $t('utils.lcode3') }}
            </p>
            <p style="color: #fff;font-size: 18px;line-height: 24px;font-weight: 700;">
              {{ count }}
            </p>
          </div>
        </div>
        <div
          style="padding: 15px;text-align: center;height:42px;float: right;margin-right: 10px;border-radius:10px;border: 1px solid rgb(71 85 105);background: rgb(30 41 59/1);font-size: 12px;color:rgb(196 181 253/1);font-weight: 500;display:flex;align-items:center;cursor:pointer;"
          @click="$router.push('lunup')"
        >
          <svg
            style="font-size: 12px;line-height: 12px;color:#fff;display:inline-block;height: 12px;"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="plus"
            class="svg-inline--fa fa-plus"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          ><path
            fill="currentColor"
            d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
          /></svg>
          <span style="font-size: 12px;padding-left: 5px;color: #fff;">
            {{ $t('utils.lcode4') }}
          </span>
        </div>
      </div>
    </div>

    <!-- 帖子列表区域 -->
    <div
      style="width: 100%;padding: 0 14px 21px 14px;position: relative;top: 15px;margin-bottom: 60px;z-index: 0;"
    >
      <div v-for="(item,index) in lists" style="width: 100%;" :key="index">
        <div
          style="margin-bottom: 15px;background: #ffffff;border-radius:15px;overflow: hidden;border: 1px solid #e2e8f0;box-shadow: 0 2px 6px rgba(0,0,0,0.04);"
        >
          <div style="padding: 14px;border-bottom-width: 1px;border-bottom: 1px solid #f1f5f9;">
            <div style="gap:10px;align-items: center;display: flex">
              <!-- 头像 -->
              <div
                style="height: 38px;width: 38px;padding: 11px;background: linear-gradient(to bottom right, #6d28d9, #d946ef, #f472b6);border-radius: 10px;"
              >
                <svg
                  style="font-size: 16px;line-height: 16px;color:#fff;display:inline-block;height: 16px;"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="circle-user"
                  class="svg-inline--fa fa-circle-user text-white text-lg"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                ><path
                  fill="currentColor"
                  d="M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
                /></svg>
              </div>
              <!-- 发帖人信息 -->
              <div style="flex: 1 1 0%">
                <div style="color:#1a202c;font-weight: 600;line-height: 22px;font-size: 16px;">
                  {{ item.username }}
                </div>
                <div style="color:#64748b;line-height: 14px;font-size: 10px;">
                  <svg
                    style="font-size: 14px;line-height: 14px;color:#64748b;display:inline-block;height: 14px;"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="calendar-days"
                    class="svg-inline--fa fa-calendar-days text-slate-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  ><path
                    fill="currentColor"
                    d="M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
                  /></svg>
                  {{ item.time }}
                </div>
              </div>
              <!-- “已认证”标签 -->
              <div
                style="padding: 4px 7px;background-color: #7c3aed;border-radius: 10px;line-height: 14px;display: inline-block;float: right;color:#fff;font-size: 10px;"
              >
                {{ $t('utils.lcode5') }}
              </div>
            </div>
          </div>
          <!-- 图片区域 -->
          <div style="padding: 14px;" @click="chankan(item.img)">
            <div
              style="background-color: #f1f5f9;border-radius: 10px;overflow: hidden;width:100%;max-height: 200px;position: relative;margin-left: auto;margin-right: auto;"
            >
              <img
                style="object-fit: cover;cursor: zoom-in;width:100%;max-height: 200px;z-index: 10;position: relative;display: block;vertical-align: middle;"
                :src="item.img"
                alt="Withdrawal certificate"
                loading="lazy"
                decoding="async"
                sizes="(max-width: 768px) 80vw, 320px"
              >
            </div>
          </div>
          <!-- 底部评论框 -->
          <div style="padding:0px 14px 14px 14px;">
            <div
              style="background-color: #f1f5f9;padding: 10px;border-radius: 10px;gap:10px;align-items: flex-start;display: flex"
            >
              <div
                style="background-color: #cbd5e1;border-radius: 7px;width: 28px;height: 28px;padding: 8px;justify-content: center;align-items: center;flex-shrink:0;display: flex"
              >
                <svg
                  style="font-size: 12px;line-height: 12px;color:#475569;display:inline-block;height: 12px;"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="comment-dots"
                  class="svg-inline--fa fa-comment-dots"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                ><path
                  fill="currentColor"
                  d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                /></svg>
              </div>
              <div style="color:#334155;font-size: 12px;line-height: 18px;padding-top: 4px;">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	<div style="height: 60px;"></div>
    <!-- 图片查看弹窗 (对应第二张图) -->
    <div
      v-if="imgs == 1"
      style="width: 100%;padding: 14px;position: fixed;background-color: rgba(0,0,0,0.7);justify-content: center;align-items: center;display: flex;z-index: 50;top: 0;right: 0;bottom: 0;left: 0;backdrop-filter: blur(2px);"
      @click="quxiao"
    >
      <div
        style="padding-bottom: 0;position: relative;width: 90%;max-width: 360px;height: auto;overflow: hidden;border-radius: 16px;z-index: 50px;background: #ffffff;box-shadow: 0 10px 40px rgba(0,0,0,0.5);"
      >
        <!-- 弹窗头部：提款证明 + 关闭按钮 -->
        <div
          style="color:#fff;font-size: 16px;height: 50px;line-height: 30px;padding: 10px 14px;justify-content: space-between;align-items: center;display: flex;background: linear-gradient(to right bottom, #6d28d9, #d946ef, #f472b6);border-radius: 16px 16px 0 0;"
        >
          <p style="font-weight: 600;font-size: 15px;">
            {{ $t('utils.lcode6') }}
          </p>
          <div
            style="background-color: rgba(255,255,255,0.2);border-radius:7px;justify-content: center;align-items: center;width: 28px;height: 28px;display:flex;padding: 8px;cursor:pointer;transition: all 0.2s;"
            @click.stop="quxiao()"
          >
            <svg
              style="font-size: 12px;line-height: 12px;color:#fff;display:inline-block;height: 12px;"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="xmark"
              class="svg-inline--fa fa-xmark"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            ><path
              fill="currentColor"
              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
            /></svg>
          </div>
        </div>

        <!-- 图片展示区域 -->
        <div style="width: 100%;padding: 14px;background: #ffffff;border-radius: 0 0 16px 16px;">
          <div
            style="background-color: #f8fafc;border-radius:10px;overflow: hidden;width:100%;"
          >
            <img
              :src="img"
              alt="Pratinjau Bukti Penarikan"
              style="max-height: 460px;object-fit: contain;width:100%;display: block;vertical-align: middle;"
              loading="lazy"
              decoding="async"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import Clipboard from "v-clipboard";
import { Icon, List, Empty, Popup } from "vant";

Vue.use(Icon).use(Clipboard).use(List).use(Empty).use(Popup);

export default {
  name: "Lun",
  data() {
    return {
      lists: [],
      report: {
        "direct_count": 0,
        "indirect_count": 0,
        "income": 0,
        "income_to": 0,
        "income_ye": 0,
        "add_count": 0,
        "add_count_to": 0,
        "add_count_ye": 0
      },
      show_share: false,
      actives:1,
      empty: false,
      loading: false,
      finished: false,
      count:"",
      imgs:0,
      img:"",
      code:""
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#0F6EFF');
      plus.navigator.setStatusBarStyle('light');
    }
    this.$parent.footer('lun');
  },
  mounted() {
    this.start();
  },
  methods: {
    quxiao(){
      this.imgs=0;
    },
    chankan(e){
      this.img=e;
      this.imgs=1;
    },
    start() {
      Fetch('/user/lun_log').then((r) => {
        this.lists = r.data.list;
        this.count = r.data.count;
      });
    },
    copy() {
      this.$toast(this.$t('recharge.copySuccess'));
    },
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  height: 100%;
  min-height: 100vh;
  padding-bottom: 30px;
  /* 浅色灰白背景衬托白色卡片 */
  background: #f4f6f9; 
}
</style>